module.exports = __webpack_public_path__ + "static/letter-square-1080w-da8358edaa6f4b498f2510b830502506.jpg";